import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import { Button, Container, Row, Col, UncontrolledCarousel } from "reactstrap";

// Core Components
const items = [
  {
    src: require("assets/img/carousel/1.jpg"),
    altText: "Slide 1",
    caption: "",
    key: "key-1",
  },
  {
    src: require("assets/img/carousel/2.jpg"),
    altText: "Slide 2",
    caption: "",
    key: "key-2",
  },
  {
    src: require("assets/img/carousel/3.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/4.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/5.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/6.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/7.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
  {
    src: require("assets/img/carousel/8.jpg"),
    altText: "Slide 3",
    caption: "",
    key: "key-3",
  },
];

function CarouselSection() {
  return (
    <>
      <div
        className="section"
        style={{
          backgroundImage: "url(" + require("assets/img/ill/1.svg") + ")",
        }}
      >
        <Container className="py-md">
          <Row className="justify-content-between align-items-center">
            <Col className="mb-lg-auto" lg="6">
              <div className="rounded overflow-hidden transform-perspective-left">
                <UncontrolledCarousel items={items} />
              </div>
            </Col>
            <Col className="mb-5 mb-lg-0" lg="5">
              <h1 className="font-weight-light">Our journey</h1>
              <p className="lead mt-4">
                Here are a few images of our training, and what the route holds
                in store for us.
              </p>
              <Button
                className="btn-white mt-4"
                color="default"
                to="/Gallery"
                tag={Link}
              >
                Gallery
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CarouselSection;
